module.exports = __webpack_public_path__ + "img/machineLearningValuationResults.9b80a01a.png";